import xtend from 'xtend'
import Model from '@nichoth/observ/model'

function WsEventHandlers (assets) {
    var state = Model.getState(assets)

    var asset = {
        update: function (asset) {
            // if the type in an update message is 'upload' we can ignore it.
            // we already have this asset state from the xhr call to crud
            if (asset.type === 'upload') return
            if (assets.data.indexed()[asset.assetID]) assets.editSync(asset)
        },

        add: function (asset) {
            // if this assetID is one that we just uploaded and it is a video,
            // set the status = 'transcoding'
            // then wait a couple seconds, and if we don't get a transcode msg
            // for this assetID, then set the status to 'archive' (what it
            // is in the assets/add message)
            if (asset.eventID) return
            var existingAsset = state.data.indexed()[asset.assetID]
            if (existingAsset) {
                return assets.editSync(asset)
            }

            assets.addSync(asset)
        },

        delete: function (asset) {
            // the model method does a check to see if this asset exists
            // so this fn is idempotent with the xhr delete response
            assets.deleteSync(asset)
        }
    }

    var thumbs = {
        add: function (data) {
            var asset = data[0]
            assets.editSync({
                assetID: asset.assetID,
                thumbnail: asset.thumbnail
            })
        },

        update: function (data) {
            var update = data[0]
            assets.editSync({
                assetID: update.assetID,
                thumbnail: update.thumbnail
            })
        }
    }

    var transcode = {
        // note -- you might get a progress message before the start message
        // so we don't want to reset the transcodeProgress here in that case
        start: function (data) {
            var existingAsset = state.data.indexed()[data.assetID]
            if (existingAsset) {
                var _data = xtend(data, {
                    transcodeProgress: existingAsset.transcodeProgress || 0
                })
                return assets.editSync(_data)
            }
        },

        processing: function (data) {
            assets.editSync({
                assetID: data.assetID,
                transcodeProgress: data.progress > 100 ? 100 : data.progress
            })
        },

        complete: function (asset) {
            assets.editSync({
                assetID: asset.assetID,
                currentStatus: asset.currentStatus
            })
        }
    }

    return {
        asset,
        thumbs,
        transcode
    }
}

// state for video uploads
// after the upload is complete, show the placeholder asset in the view
// listen for transcode messages for that asset
// note the asset/add msg has the status = archive, but then like a second
// later we get the message that the transocde has started, and the
// status is now 'trancoding'


// { assets<model>, ws<event emitter> }
function SubscribeToWebsocket ({ assets, ws }) {
    var wsEventHandlers = WsEventHandlers(assets)

    ws.on('data', function (msg) {
        var { method, type } = msg.action
        if (process.env.NODE_ENV === 'development') {
            // console.log('**', method, type)
        }
        var fn = (wsEventHandlers[method] || {})[type]
        if (!fn) return
        fn(msg.data)
    })
}

export default SubscribeToWebsocket
